<template>
    <v-card flat>
        <v-overlay :value="loadingShopData">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-toolbar dense color="bal-gray">
            <v-toolbar-title>{{ $route.params.shopId === "new" ? "Add new" : activeShop.name | t }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="submitEdit" dark color="bal-red">
                <v-icon>done</v-icon>
                {{ "Save" | t }}
            </v-btn>
            <v-btn @click="closeDrawer()" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab v-for="item in tabs" :key="item" style="text-transform: none !important;">
                {{ item | t }}
            </v-tab>
            <v-tab-item>
                <general-info-edit-tab />
            </v-tab-item>
            <v-tab-item>
                <store-info-edit-tab />
            </v-tab-item>
            <v-tab-item>
                <contacts-info-edit-tab />
            </v-tab-item>
            <v-tab-item>
                <codes-edit-tab />
            </v-tab-item>
            <v-tab-item>
                <merge-shops-edit-tab />
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import GeneralInfoEditTab from "./shops-admin-tab-items/general-info-edit-tab";
import ContactsInfoEditTab from "./shops-admin-tab-items/contacts-info-edit-tab";
import Store from "../../store";
import StoreInfoEditTab from "@/pages/shops-admin/shops-admin-tab-items/store-info-edit-tab";
import MergeShopsEditTab from "@/pages/shops-admin/shops-admin-tab-items/merge-shops-edit-tab";
import CodesEditTab from "@/pages/shops-admin/shops-admin-tab-items/codes-edit-tab";

export default {
    name: "shops-admin-edit",
    components: { CodesEditTab, MergeShopsEditTab, StoreInfoEditTab, GeneralInfoEditTab, ContactsInfoEditTab },

    data() {
        return {
            tab: 0,
            tabs: ["General info", "Store info", "Contacts info", "Codes", "Merge shop"]
        };
    },
    mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        if (this.$route.params.shopId === "new") {
            Store.commit("ShopsAdminStore/addNewProduct");
        } else {
            Store.dispatch("ShopsAdminStore/getShopData", this.$route.params.shopId);
        }
        if (this.$route.params.tab) {
            this.tab = this.tabs.indexOf(this.$route.params.tab);
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    computed: {
        ...mapState("ShopsAdminStore", [
            "activeShop",
            "loadingShopData",
            "imageFile",
            "tableOptions",
            "searchShopString"
        ])
    },
    methods: {
        ...mapMutations("ShopsAdminStore", ["resetActiveShop", "setErrorMessage", "setRequestError"]),
        ...mapActions("ShopsAdminStore", ["submitShopUpdate"]),
        closeDrawer() {
            this.resetActiveShop();
            this.$router.push({ name: "shops-admin-list" });
        },
        async submitEdit() {
            const response = await this.submitShopUpdate({
                shop: this.activeShop,
                image: this.imageFile
            });
            if (response.status === 1) {
                await this.$router.push({
                    name: "shops-admin-view",
                    params: { shopId: response.id, tab: this.tabs[this.tab] }
                });
                await Store.dispatch("ShopsAdminStore/getShopsList", {
                    options: this.tableOptions,
                    search: this.searchShopString
                });
            } else {
                this.setRequestError(true);
                this.setErrorMessage("Shop code must be unique");
            }
        },
        handleKeyboardListener(e) {
            if (e.keyCode === 83 && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.submitEdit();
            }
            if (
                document.activeElement.tagName !== "INPUT" &&
                document.activeElement.tagName !== "TEXTAREA" &&
                document.activeElement !== document.querySelector(".ProseMirror-focused") //tipTap editor
            ) {
                if (e.key === "ArrowLeft") {
                    if (this.tab > 0) {
                        this.tab -= 1;
                    }
                } else if (e.key === "ArrowRight") {
                    if (this.tab + 1 < this.tabs.length) {
                        this.tab += 1;
                    }
                }
            }
        }
    }
};
</script>

<style scoped></style>
